// extracted by mini-css-extract-plugin
export default {"container":"GettingStartedSection_container__DZHps","coloured-top":"GettingStartedSection_coloured-top__Q4He-","content":"GettingStartedSection_content__nw1Pb"};